// extracted by mini-css-extract-plugin
export default {"loaderImage":"loader_loaderImage__sMRK1"};